// VDV-1608
export const isMicrosoftSsoEnabled = (): boolean => process.env.REACT_APP_FEATURE_FLAG_MICROSOFT_SSO === 'true'

// VDV-1938
export const isValkTalkEnabled = (): boolean => process.env.REACT_APP_FEATURE_FLAG_VALK_TALK === 'true'
